"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOneAsicsApi = void 0;

var _oauthApi = require("./oauthApi");

var _storesApi = require("./storesApi");

var _usersApi = require("./usersApi");

var createOneAsicsApi = function createOneAsicsApi(baseUrl) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'v1';
  var baseApiPath = "".concat(baseUrl, "/api/").concat(version);
  return {
    baseApiPath: baseApiPath,
    baseUrl: baseUrl,
    oauthApi: (0, _oauthApi.createOauthApi)(baseUrl),
    storesApi: (0, _storesApi.createStoresApi)(baseApiPath),
    usersApi: (0, _usersApi.createUsersApi)(baseApiPath)
  };
};

exports.createOneAsicsApi = createOneAsicsApi;